export default function StartVerificationButton({ onClick, isLoading }) {
  return (
    <div className="bg-background shadow-sm border border-gray-50 rounded-lg p-6">
      <h3 className="text-lg font-semibold mb-4">Begin Verification</h3>
      <button
        onClick={onClick}
        className="bg-secondary-600 text-white px-4 py-2 rounded hover:bg-secondary-600 transition-colors"
        disabled={isLoading}
      >
        {isLoading ? 'Starting...' : 'Start Verification'}
      </button>
      <p className="text-sm text-gray-600 mt-2">
        Click to begin the verification process. This will change the status to "In Review", and the
        verification is going to be assigned to you.
      </p>
    </div>
  )
}
